<template>
  <Recover />
</template>

<script>
import Recover from '@/components/login/PasswordRecoverForm.vue'

export default {
  name: 'RecoverPage',
  components: { Recover }
}
</script>

<style scoped>

</style>
